import type { StepState } from './Stepper.types.js';

// Helpers
export const computeStepState = (
  isCompleted: boolean,
  isActive: boolean,
  hasError: boolean,
): StepState => {
  if (isCompleted && !hasError) return 'completed';
  if (isActive && !hasError && !isCompleted) return 'active';
  if (hasError) return 'error';
  return 'inactive';
};
